<template>
    <div class = "commom-dialog">
        <el-dialog
            :title="optionsData.title || '标题'"
            :visible.sync="isShow"
            :width = "optionsData.width || '50%'"
            :center = "!!optionsData.center"
            :show-close = "!!optionsData.showClose"
            :before-close="optionsData.onCloseBefore&&onCloseBefore"
            :close-on-click-modal = "!!optionsData.isCanClickClose"
            :destroy-on-close = "!!optionsData.destroyOnClose"
            :top ="options.top"
            :append-to-body="optionsData.appendToBody"
            @opened = "onOpenAfter"
            >
            <slot></slot>
            <span v-if = "optionsData.buttons && optionsData.buttons.length" slot="footer" class="dialog-footer">
                <el-button v-for = "(btnConf, index) in optionsData.buttons" :class="{'one-btn': optionsData.buttons.length==1}" :key = "index" @click="buttonHandler($event, btnConf)">{{btnConf.text}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import _ from "lodash";

 
export default {
    
  data () {
    return {
      isShow: false,
      optionsData: {}
    };
  },
  props: {
    options:{
      type:Object,
      default:() => {
        return {};
      }
    }
  },
  computed:{
    height () {
      return this.optionsData.height?( this.pxToVw(parseInt(this.optionsData.height) || 600)):"";
    },
  },
  mounted () {
    _.assign(this.optionsData, this.options);
  },
  methods: {
    dialog (opts,...params){
      if(_.isString(opts)){
        if(params.length>1){
          return this[opts].call(this,params[0],params[1]);
        }else{
          return this[opts].call(this,params[0]);
        }
      }else{
        //传进来参数是对象 就和options合并 并赋值
        _.assign(this.optionsData, this.options,opts);
        return this;
      }
    },
    buttonHandler: _.throttle(function (event, btnConf) {
      return Promise.all([
        _.isFunction(btnConf.handler) ? btnConf.handler(event, btnConf) : true
      ]).then(([flag]) => {
        if(flag == false) {
          return;
        } else {
          this.close();
        }
      });
    }, 1000, { "trailing": false }),
    onOpenAfter () {
            
    },
    open () {
      this.isShow = true;
      this.$nextTick(() => {
        this.resize();
        _.isFunction(this.optionsData.onOpenAfter) && this.optionsData.onOpenAfter(this.$el);
      });
      return this;
    },
    close () {
      this.isShow = false;
      this.$nextTick(() => {
        _.isFunction(this.optionsData.onCloseAfter) && this.optionsData.onCloseAfter(this.$el);
      });
      return this;
    },
    onCloseBefore () {
      _.isFunction(this.optionsData.onCloseBefore) && this.optionsData.onCloseBefore(this.$el);
    },
    /**
         * px转换为vm方法
         *  @param value 传入的px值
         * */
    pxToVw (value){
      value = value + "";
      const pxGlobRegExp = new RegExp(/(\d+)/.source, "ig");
      /**
             * px转换为vm方法
             *  @param minPixelValue 小于或等于`1px`时不转换为视窗单位,默认为1
             *  @param unitPrecision 指定`px`转换为视窗单位值的小数位数，默认为3个小数点
             *  @param viewportSize  横屏时使用的视窗宽度 取window.sreen.height
             * */
      const createPxReplace = function (minPixelValue, unitPrecision, viewportSize){
        return function (m, $1) {
          if (!$1) return m;
          var pixels = parseFloat($1);
          if (pixels <= minPixelValue) return m;
          var parsedVal = (pixels / viewportSize * 100);
          return parsedVal === 0 ? 0 : parsedVal.toFixed(unitPrecision) + "vw";
        };
      };
      return value.replace(pxGlobRegExp, createPxReplace(1, 3, document.documentElement.clientWidth));
    },
    resize () {
      var bodyDom = this.$el.querySelector(".el-dialog__body");
      //  bodyDom.style.height = this.height;
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/styles/less/variable.less";
 .commom-dialog {
  /deep/ .el-dialog__wrapper {
        overflow: hidden;
        display: flex;
        align-content: center;
        align-items: center;
        color: #3e191d;
        .el-dialog{
            border-radius: 6px;
            .el-dialog__header {
                font-weight: bolder;
                border-bottom: 1px solid #e8eaec;
                padding: 14px 16px;
                line-height: 1;
                text-align: left;

                display: flex;
                align-items: center;
                justify-content: space-between;
                text-align: left;
                padding-left: 20px;
                color: #D0AA72;
                letter-spacing: 1px;
                line-height: 42px;
                height: 42px;
                font-weight: 600;
                background-image: linear-gradient(90deg, #F4E4CE 0%, #FFFFFF 100%);
                .fontsize-title-small();
                .el-dialog__title {
                  color: #D0AA72;
                  // line-height: 20px;
                  // font-size: 16px;
                  // color: #17233d;
                  // font-weight: 500;
                  // overflow: hidden;
                  // text-overflow: ellipsis;
                  // white-space: nowrap;
                  // text-align: left;
                  // .fontsize-title-small();
                  // display: flex;
                  // align-items: center;
                  // justify-content: space-between;
                  // text-align: left;
                  // padding-left: 20px;
                  // color: #D0AA72;
                  // letter-spacing: 1px;
                  // line-height: 42px;
                  // height: 42px;
                  // font-weight: 600;
                  // background-image: linear-gradient(90deg, #F4E4CE 0%, #FFFFFF 100%);
                  // .fontsize-title-small();
                }
                .el-dialog__headerbtn{
                  top: 10px;
                  font-size: 22px;
                }
            }
            .el-dialog__body {
              overflow-y: auto;
              overflow-x: hidden;
              max-height: 850px;
              .fontsize-text-medium();
            }
            .el-dialog__footer {
                padding: 20px;
                display: flex;
                justify-content: center;
                border-top: 1px solid #e8eaec;
                justify-content: flex-end;
                .el-button {
                  border-radius: 3px;
                  border: 1.5px solid #dcb369;
                  padding: 0 15px;
                  font-size: 14px;
                  border-radius: 4px;
                  transition: color .2s linear,background-color .2s linear,border .2s linear,box-shadow .2s linear;
                  background: #dcb369;
                  color: #ffffff;
                  padding:0 20px;
                  .fontsize-btn-medium();
                  width: auto;
                  min-width: 90px;
                  height: 32PX;
                  padding: 0;
                  margin-left: 16px;
                  &:first-child {
                    margin-left: 0;
                    color: #e5c48a;
                    background: linear-gradient(45deg,#fff,#fff);
                    border: 1px solid #e5c48a;
                    border-radius: 0.04rem
                  }
                }
                .el-button.one-btn{
                  background: #dcb369;
                  color: #fff;
                  margin-left: 0;
                }
            }
    
            .el-dialog--center {
                .el-button+.el-button {
                    margin-left: 40px !important;
                }
            }
    
            .el-dialog__body {
                padding: 10px;
            }
        }
        
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/dialog.vue